import { observer } from 'mobx-react';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { CQAppConstant } from '../../../../app-constants';
import { ActionType, CQCombobox, IOption } from '../../../../common/cq-inputs';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { LSTemplatesStore } from '../../../../store/ls-template-store';
import { IFieldData } from '../../component-level-fields/component-field';

interface IProps {
    fieldData: IFieldData;
    templateName: string;
    updateComponent: (value: string) => void;
}

const CQActionOverride = (props: IProps) => {
    const { fieldData: { value, inputParamKey, defaultValue }, templateName, updateComponent } = props;
    const outputConfigObject = CQMasterDataStore.OutputConfig.getStoreData(templateName);

    const [dropDownList, setDropDownList] = useState<IOption[]>([]);
    const [state, setState] = useState(outputConfigObject[inputParamKey] || defaultValue);
    const [templateInfo] = useState<any>(() => {
        return LSTemplatesStore.selectedTemplate;
    });

    useEffect(() => {
        CQMasterDataStore
            .OutputConfig
            .updateTemplatePropertyValue(templateName, CQAppConstant.ACTION_OVERRIDE, state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    useEffect(() => {
        const dropDown = getComboBoxValues();
        setDropDownList(dropDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const valueChanged = (value: string) => {
        setState(value);
        updateSuffix(value);
        updateComponent(value);
    }

    function updateSuffix(value: string) {
        let suffixValue = value;
        if(value === CQAppConstant.NONE) {
            suffixValue = '';
        } else  if(value === 'New') {
            suffixValue = 'Create';
        }

        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(templateName, 'suffixName', suffixValue);
    
        if (
            templateInfo.name === "cqForm100" &&
            !value
        ) {
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(
                templateName,
                "recordTypeDeveloperName",
                ""
            );
        }
    }

    function getComboBoxValues() {
        const options: IOption[] = []
        if(value && value.length > 0) {
            value.forEach((val: any, index: number) => {
                options.push({
                    id: `${val}${index}`,
                    value: val,
                    label: val
                })
            });
        }
        
        return options;
    }

    function onActionPerformed(actionType: ActionType, result: IOption[]) {
        if(actionType === 'item-cleared' || actionType === 'item-selected') {
            valueChanged(result.length === 0 ? '' : result[0].value)
        }
    }

    return(
        <CQCombobox
            key= {inputParamKey}
            value={outputConfigObject[inputParamKey]}
            label={{
                label: "",
                placeholder: "",
            }}
            onActionPerformed={(actionType, result) => onActionPerformed(actionType, result as IOption[])}
            options={dropDownList}
            limit={dropDownList.length}
            config={{
                variation: 'readonly',
            }}
        />
    )
}

export default observer(CQActionOverride);